import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {useQuery} from '@apollo/client';
import Avatar from '../../components/Avatar';
import {QUERY_CLIENT_LIKES_LIST} from './graphql';
import Query from '../../components/Query';
import Icon from '../../components/Icon';
import ForumHow from '../Forum/How';

const ClientLikesList = () => {
  const [days, setDays] = useState(7);
  const [howIsOpen, setHowOpen] = useState(false);

  const query = useQuery(QUERY_CLIENT_LIKES_LIST, {variables: {days}, fetchPolicy: 'cache-and-network'});

  return (
    <div className="ClientLikesList">
      <div className="mb-4" style={{height: 40}}>
        <div className="row align-items-center justify-content-between">
          <div className="col-auto font-5">Топ недели</div>
          <div className="col-auto">
            <button
              className="btn btn-sm px-3 py-1 border border-primary rounded-pill"
              onClick={() => setHowOpen(true)}
            >
              {/* <Icon name="question-circle" size={30} /> */}
              <span>Помощь</span>
            </button>
          </div>
        </div>
      </div>
      <div className="btn-group mb-3">
        <button onClick={() => setDays(7)} className={`btn btn${days !== 7 ? '-outline' : ''}-primary`}>
          Неделя
        </button>
        <button onClick={() => setDays(30)} className={`btn btn${days !== 30 ? '-outline' : ''}-primary`}>
          Месяц
        </button>
        <button onClick={() => setDays(365)} className={`btn btn${days !== 365 ? '-outline' : ''}-primary`}>
          Год
        </button>
        <button onClick={() => setDays(undefined)} className={`btn btn${days !== undefined ? '-outline' : ''}-primary`}>
          Всего
        </button>
      </div>
      <div className="border bg-white rounded overflow-hidden">
        {Query(query) || (
          <div className="list-group list-group-flush">
            {query.data.clientLikesList.map(item => (
              <div key={item.id} className="list-group-item list-group-item-action py-3">
                <div className="row align-items-center gx-3">
                  <div className="col-auto">
                    <Avatar user={item.user} size={50} />
                  </div>
                  <div className="col">
                    <div>{item.user.fullname}</div>
                    <div className="font-2 text-muted">{item.likesCount} лайков</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <ForumHow isOpen={howIsOpen} onClose={() => setHowOpen(false)} />
    </div>
  );
};

export default ClientLikesList;
